import React from "react"

import { Box, Flex } from "@chakra-ui/react"

import { BugReport } from "components/BugReport"

import { Sidebar } from "./Sidebar"

interface Props {
  children: React.ReactNode
}

export function Layout(props: Props) {
  return (
    <Box bg="white">
      <Flex w="100vw" h="100vh" overflow="hidden">
        <Sidebar w="16rem" />

        <Box
          px={{ base: 4, md: 6, xl: 10 }}
          py={0}
          flexGrow={2}
          overflow="scroll"
        >
          {props.children}
        </Box>

        <BugReport
          position="fixed"
          bottom={{ base: "1rem", lg: "1.5rem" }}
          right="1.5rem"
        />
      </Flex>
    </Box>
  )
}
